import * as React from 'react';
import classnames from 'classnames';
import { SkipLink } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const PageLayout = ({ children , header , preFooter , footer , fixedBottomBarContent , hasSiteNav =true , hasOnlyLogoInHeader =false ,  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('page-layout', {
            'page-layout--with-header': !!header,
            'page-layout--with-nav': hasSiteNav,
            'page-layout--with-logo-header': hasOnlyLogoInHeader
        })
    }, /*#__PURE__*/ React.createElement(SkipLink, {
        targetId: "main-content"
    }, getLabel('common.skipLink')), header && /*#__PURE__*/ React.createElement("div", {
        className: "page-layout__header"
    }, header), /*#__PURE__*/ React.createElement("main", {
        role: "main",
        id: "main-content",
        className: "page-layout__main"
    }, children, preFooter && /*#__PURE__*/ React.createElement("div", {
        className: "page-layout__pre-footer"
    }, preFooter)), footer && /*#__PURE__*/ React.createElement("div", {
        className: "page-layout__footer"
    }, footer), fixedBottomBarContent);
};

export { PageLayout };
//# sourceMappingURL=PageLayout.js.map
